import { get } from '../../util/http'
import {
  entityExists,
  getEntity,
  selectEntities
} from './entities'
import * as schema from '../schema'
import { normalize } from 'normalizr'
import { wrapDispatch } from 'multireducer'
import {fromJS, List} from 'immutable'
import { loadContentEntity, selectActiveContent, selectEntityExists, selectEntityIsLoading } from './content'
import { createSelector } from 'reselect'
import { denormalize } from 'normalizr'
import {PROCESS_PROBLEM} from './grandmaster'
import content from './content'
import {selectNthFromCurrentIdInFlatmap} from './topicFlatMap'
import reducerRegistry from '../reducerRegistry'
import multireducer from 'multireducer/immutable'

/**
 * Actions
 */
export const ATTEMPT_GET_TOPIC = 'expii/topic/ATTEMPT_GET_TOPIC'
export const CLEAR_SOLUTIONS = 'expii/topic/CLEAR_SOLUTIONS'
export const PROCESS_TOPIC = 'expii/topic/PROCESS_TOPIC'
const APPLY_EXPLANATION_FILTER = 'expii/topic/APPLY_EXPLANATION_FILTER'
const ADD_ACTIVE_EXPLANATION_ID = 'expii/topic/ADD_ACTIVE_EXPLANATION_ID'
const REMOVE_ACTIVE_EXPLANATION_ID = 'expii/topic/REMOVE_ACTIVE_EXPLANATION_ID'
const CHOOSE_ACTIVE_PROBLEM_ID = 'expii/topic/CHOOSE_ACTIVE_PROBLEM_ID'
const ADD_ACTIVE_SOLUTION_ID = 'expii/topic/ADD_ACTIVE_SOLUTION_ID'
const PROCESS_TOPIC_ERROR = 'expii/topic/PROCESS_TOPIC_ERROR'

/**
 * Other Constants
 */
export const EXPLANATION_FILTERS = {
  All: null,
  Text: 'text',
  Video: 'video'
}
export const SUBJECT_TOPICS = new Set([
  8951, //Math Foundations
  4106, //Algebra 1
  752, //Geometry
  4712, //Algebra 2
  1, //Calculus
  5525, //Advanced Topics
  9213, //Earth Science
  10005, //HS Biology
  7587, //Biology
  7954, //Chemistry
  1618, //Physics
  1943 //Astronomy
])
/**
 * Reducer
 */
const defaultTopicState = fromJS({
  isFetching: false,
  isHidden: false,
  topic: {},
  explanationFilter: null,
  activeExplanationIds: [],
  activeProblemId: 0,
  activeSolutionIds: [],
  errorMessage: null,
})

export default function reducer(state = defaultTopicState, action = {}) {
  switch (action.type) {
  case ATTEMPT_GET_TOPIC:
    return state.withMutations(map =>
      map.set('isFetching', true).set('topic', `${action.topicId}`).set('explanationFilter', null).set('activeExplanationIds',List())
    )
  case CLEAR_SOLUTIONS:
    return state.set('activeSolutionIds', List())
  case PROCESS_TOPIC:
    const isHidden = action.payload.isHidden
    const topic = action.payload.topic
    return state.merge(
      fromJS({
        topic: `${topic}`,
        isFetching: false,
        isHidden: isHidden,
      })
    )
  case PROCESS_PROBLEM: {
    const topic = action.payload.baseTopicId
    return state.merge(
      fromJS({
        topic: `${topic}`
      })
    )
  }
  case PROCESS_TOPIC_ERROR:	{
    return state.withMutations(map =>
      map.set('isFetching', false).set('errorMessage', action.errorMessage)
    )
  }
  case APPLY_EXPLANATION_FILTER:
    return state.set('explanationFilter', EXPLANATION_FILTERS[action.filter])
  case ADD_ACTIVE_EXPLANATION_ID:
    return state.withMutations(s => {
      /**
          This is where we keep track of what explanation
          ids are currently available to the client on the current
          topic page. The size of this list is actually used to add to the content
          multireducer
        */
      let activeExplanationIds = s.get('activeExplanationIds')
      activeExplanationIds = activeExplanationIds.push(action.explanationId)
      return s.set('activeExplanationIds', activeExplanationIds)
    })
  case CHOOSE_ACTIVE_PROBLEM_ID:
    return state.set('activeProblemId', action.problemId)
  case ADD_ACTIVE_SOLUTION_ID:
    return state.withMutations(s => {
      /**
          This is where we keep track of what solution
          ids are currently available to the client on the current
          topic page. The size of this list is actually used to add to the content
          multireducer
        */
      let activeSolutionIds = s.get('activeSolutionIds')
      activeSolutionIds = activeSolutionIds.push(action.solutionId)
      return s.set('activeSolutionIds', activeSolutionIds)
    })
  default:
    return state
  }
}

/**
 * Action Creators
 */
export function attemptGetTopic(topicId) {
  return { type: ATTEMPT_GET_TOPIC, topicId }
}

export function processTopic(topic_data) {
  return { type: PROCESS_TOPIC, payload: topic_data }
}

export function applyExplanationFilter(filter) {
  return { type: APPLY_EXPLANATION_FILTER, filter }
}

export function addActiveExplanationId(explanationId) {
  return { type: ADD_ACTIVE_EXPLANATION_ID, explanationId }
}

export function chooseActiveProblemId(problemId) {
  return { type: CHOOSE_ACTIVE_PROBLEM_ID, problemId }
}

export function addActiveSolutionId(solutionId) {
  return { type: ADD_ACTIVE_SOLUTION_ID, solutionId }
}

export function processTopicError(errorMessage) {
  return {type: PROCESS_TOPIC_ERROR, errorMessage}
}

/**
 * Side Effects
 */
export function handleNewContent(topicId, newContent) {
  return (dispatch, getState) => {
    return dispatch(fetchRemoteTopic(topicId)).then(json => {
      const {activeExplanationId, ...rest} = json
      dispatch(processTopic(rest))

      const {type, id, solution} = newContent
      if (type === 'explanation') {
        dispatch(addActiveExplanation(parseInt(id)))
      } else if (type === 'problem') {
        dispatch(chooseActiveProblem(parseInt(id)))
        if (solution) {
          dispatch(addActiveSolution(parseInt(solution)))
        }
      } else if (type === 'problem_solution') {
        dispatch(addActiveSolution(parseInt(id)))
      }
    })
  }
}

// This is definitely a strange way of doing this. But in order to be able to
// continually load more explanations, we need to dynamically alter our reducers
// For now, I've placed that alteration here, but it doesn't feel right to do that.
const contentReducers = {
  leafProblem: content,
  leafSolution: content,
  grandmasterProblem: content,
  grandmasterSolution: content,
  grandmasterExplanation: content
}
export function addActiveExplanation(explanationId) {
  return (dispatch, getState) => {
    if (!getState().hasIn(['contentCollection',`leafExplanation${explanationId}`])) {
      contentReducers[`leafExplanation${explanationId}`] = content
      reducerRegistry.register('contentCollection', multireducer(contentReducers))
    }
    //Load Explanation into to content reducer
    wrapDispatch(dispatch, `leafExplanation${explanationId}`)(
      loadContentEntity('explanation', explanationId)
    )
    //Add explanation id to activeExplanationIds in topic reducer
    dispatch(addActiveExplanationId(explanationId))
  }
}

export function chooseActiveProblem(problemId) {
  return (dispatch, getState) => {
    wrapDispatch(dispatch, 'leafProblem')(
      loadContentEntity('problem', problemId)
    )
    dispatch(chooseActiveProblemId(problemId))
  }
}

export function addActiveSolution(solutionId) {
  return (dispatch, getState) => {
    const numSolutionsActive = getState().getIn(['topic','activeSolutionIds']).size
    if (!getState().hasIn(['contentCollection',`leafSolution${numSolutionsActive}`])) {
      contentReducers[`leafSolution${numSolutionsActive}`] = content
      reducerRegistry.register('contentCollection', multireducer(contentReducers))
    }
    //Load Solution into to content reducer
    wrapDispatch(dispatch, `leafSolution${numSolutionsActive}`)(
      loadContentEntity('solution', solutionId)
    )
    //Add solution id to activeSolutionIds in topic reducer
    dispatch(addActiveSolutionId(solutionId))
  }
}
function fetchRemoteTopic(topicId) {
  return (dispatch, getState) => {
    dispatch(attemptGetTopic(topicId))
    return get(`/api/v2/topic/${topicId}`).then(json => {
      let { success, output } = json
      const activeExplanationId =
        Object.prototype.hasOwnProperty.call(output, 'explanations') && output.explanations.length
          ? output.explanations[0].id
          : 0
      const normalized = normalize(output, schema.topic)
      json = {
        isHidden: output.isHidden,
        success: success,
        topic: normalized.result,
        entities: normalized.entities,
        activeExplanationId
      }
      return json
    }).catch(json => {
      return dispatch(processTopicError(json.error_message))
    })
  }
}

function handleProcessTopic(dispatch, getState, json) {
  const {activeExplanationId, ...rest} = json
  dispatch(processTopic(rest))
  dispatch(loadNextNExplanations())
}

export function loadNextNExplanations(n = 5) {
  return (dispatch, getState) => {
    const explanations = getEntity(getState(), 'topic', getState().getIn(['topic','topic'])).get('explanations')
    const currIndex = getState().getIn(['topic','activeExplanationIds']).size
    for (let i  = currIndex; i < Math.min(currIndex+n, explanations.size); i++) {
      const e = explanations.get(i)
      dispatch(addActiveExplanation(e))
    }
  }
}

export function clearSolutions() {
  return { type: CLEAR_SOLUTIONS }
}

export function loadSolutions() {
  return (dispatch, getState) => {
    dispatch(clearSolutions())
    const activeProblemId = getState().getIn(['topic','activeProblemId'])
    const problem = getState().getIn(['entities','problem', activeProblemId])
    if (problem) {
      const solutions = problem.get('solutions')
      const currIndex = getState().getIn(['topic','activeSolutionIds']).size
      for (let i  = currIndex; i < solutions.size; i++) {
        const e = solutions.get(i)
        dispatch(addActiveSolution(e))
      }
    }
  }
}

export function getTopic(topicId) {
  return (dispatch, getState) => {
    dispatch(attemptGetTopic(parseInt(topicId, 10)))
    if (entityExists(getState(), 'topic', topicId)) {
      //Topic to some extent exists in redux.

      const topic = getEntity(getState(), 'topic', topicId)
      dispatch(processTopic({topic: topicId}))
      if (
        (!topic.has('explanations') && topic.get('isLeaf')) ||
        (!topic.has('leaves') && !topic.get('isLeaf'))
      ) {
        //We still have to fetch the content data
        dispatch(fetchRemoteTopic(topicId)).then(json=>{
          handleProcessTopic(dispatch, getState, json)
        })
      } else {
        //Topic in its entirety already exists in redux.
        dispatch(loadNextNExplanations())
      }
    } else {
      //We need to fetch the entire topic.
      dispatch(fetchRemoteTopic(topicId)).then(json => {
        handleProcessTopic(dispatch, getState, json)
      }).catch(message => {
        return processTopicError(dispatch, getState, message )
      })
    }
  }
}

/**
 * Selectors
 */
const selectTopicId = state => {
  return state.getIn(['topic', 'topic'])
}
const selectExplanationFilter = state => {
  const explanationFilter = state.getIn(['topic', 'explanationFilter'])
  return explanationFilter
}
const selectActiveProblemId = state => {
  return state.getIn(['topic', 'activeProblemId'])
}

export function getBreadcrumbsFromTopic(topic) {
  let breadcrumbTopics = []
  if (topic.get('depth') > 2) {
    breadcrumbTopics.push(topic.get('parent'))
    if (topic.getIn(['parent', 'depth']) > 2) {
      let tempTopic = topic.get('parent')
      while (tempTopic.get('depth') > 2) {
        tempTopic = tempTopic.get('parent')
      }
      if (tempTopic.get('id') !== topic.getIn(['parent', 'id'])) {
        breadcrumbTopics = [tempTopic, topic.get('parent')]
      }
    }
  }
  return fromJS(breadcrumbTopics)
}

export const makeSelectTopic = () => {
  return createSelector(
    [selectTopicId, selectEntities],
    (topicId, entities) => {
      const topic = denormalize(topicId, schema.topic, entities)
      const breadcrumbs = getBreadcrumbsFromTopic(topic)
      return topic.withMutations((t)=>{
        let hasProblems = false
        if (t.has('problems')) {
          hasProblems = t.get('problems').size >= 3
        }
        return t.set('breadcrumbs', breadcrumbs)
          .set('practiceEnabled',(t.get('isLeaf') && hasProblems) || (t.has('leaves') && t.get('leaves').size) || SUBJECT_TOPICS.has(t.get('id')))
      })
    }
  )
}

export const selectTopic = state => {
  const topicId = selectTopicId(state)
  const entities = selectEntities(state)
  const topic = denormalize(topicId, schema.topic, entities)
  const breadcrumbs = getBreadcrumbsFromTopic(topic)
  return topic.withMutations((t)=>{
    let hasProblems = false
    if (t.has('problems')) {
      hasProblems = t.get('problems').size >= 3
    }
    return t.set('breadcrumbs', breadcrumbs)
      .set('practiceEnabled',(t.get('isLeaf') && hasProblems) || (t.has('leaves') && t.get('leaves').size) || SUBJECT_TOPICS.has(t.get('id')))
  })
}

export const makeSelectExplanations = selectTopic => {
  return createSelector(
    [selectTopic, selectExplanationFilter],
    (topic, explanationFilter) => {
      let explanations = List()
      if (
        topic.get('isLeaf') &&
        topic.has('explanations') &&
        explanationFilter
      ) {
        explanations = topic
          .get('explanations')
          .filter(e => e.get('contentType') === explanationFilter)
      } else if (topic.get('isLeaf') && topic.has('explanations')) {
        explanations = topic.get('explanations')
      }
      return explanations
    }
  )
}

export const makeSelectProblems = selectTopic => {
  return createSelector(
    [selectTopic],
    (topic) => {
      let problems = List()
      if (
        topic.get('isLeaf') &&
        topic.has('problems')
      ) {
        problems = topic.get('problems')
      }
      return problems
    }
  )
}

// Solutions need to be pulled out separately so upvotes are
// reflected everywhere properly. Still need to determine which approach is better
export const makeSelectSolutions = (selectProblems) => {
  return createSelector(
    [selectProblems, selectActiveProblemId],
    (problems, activeProblemId) => {
      let solutions = List()
      const problem = problems.find((obj) => parseInt(obj.get('id')) === parseInt(activeProblemId))
      if (problem) {
        solutions = problem.get('solutions')
      }
      return solutions
    }
  )
}
export const selectSolutions = (state) => {
  const activeProblemId = state.getIn(['topic','activeProblemId'])
  const problem = state.getIn(['entities','problem', activeProblemId])
  const allSolutions = state.getIn(['entities','problem_solution'])
  let solutions = List()
  if (problem) {
    const problemSolutions = problem.get('solutions')
    solutions = allSolutions.filter((v,k)=> {
      return problemSolutions.includes(parseInt(k))
    })
  }
  return {
    'solutions': solutions.toIndexedSeq().toList()
  }
}

export const selectActiveExplanation = (state, as) => {
  return {
    activeContent: selectActiveContent(state, as),
    entityExists: selectEntityExists(state, as),
    isLoading: selectEntityIsLoading(state, as),
  }
}

export const selectActiveProblem = state => {
  return {
    activeContent: selectActiveContent(state, 'leafProblem'),
    entityExists: selectEntityExists(state, 'leafProblem'),
    isLoading: selectEntityIsLoading(state, 'leafProblem'),
  }
}


export const selectActiveSolution = (state, as)  => {
  return {
    activeContent: selectActiveContent(state, as),
    entityExists: selectEntityExists(state, as),
    isLoading: selectEntityIsLoading(state, as),
  }
}
export const selectNthLeafFromCurrent = (state, n) => {
  const nextTopicId = selectNthFromCurrentIdInFlatmap(state, n)
  const entities = selectEntities(state)
  const topic = denormalize(nextTopicId, schema.topic, entities)
  if (topic && topic.has('explanations')) {
    const breadcrumbs = getBreadcrumbsFromTopic(topic)
    return topic.withMutations((t)=>{
      let hasProblems = false
      if (t.has('problems')) {
        hasProblems = t.get('problems').size >= 3
      }
      return t.set('breadcrumbs', breadcrumbs)
        .set('practiceEnabled',(t.get('isLeaf') && hasProblems) || (t.has('leaves') && t.get('leaves').size) || SUBJECT_TOPICS.has(t.get('id')))
    })
  } else {
    return false
  }

}



// WEBPACK FOOTER //
// ./src/redux/modules/topic.js